export default "__VITE_ASSET__OSoE55sa__"